import { Component, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { YesNoModalDialogModel } from './yes-no-modal-dialog.model';

@Component({
    selector: 'pace-core-yes-no-model-dialog',
    templateUrl: './yes-no-modal-dialog.component.html',
    styleUrls: ['./yes-no-modal-dialog.component.scss'],
    standalone: false,
})
export class YesNoModalDialogComponent {
    @Input()
    public model: YesNoModalDialogModel;

    public modalResult = new Subject<boolean>();
    public constructor(public readonly modalInstance: BsModalRef) {}

    public onYesClicked(): void {
        this.modalResult.next(true);
        this.modalResult.complete();
        this.modalInstance.hide();
    }

    public onNoClicked(): void {
        this.modalResult.next(false);
        this.modalResult.complete();
        this.modalInstance.hide();
    }

    public onCancelClick(): void {
        this.modalResult.next(true);
        this.modalResult.complete();
        this.modalInstance.hide();
    }
}
